import { render, staticRenderFns } from "./DayWasteGasReportModal.vue?vue&type=template&id=796e134e&scoped=true&"
import script from "./DayWasteGasReportModal.vue?vue&type=script&lang=js&"
export * from "./DayWasteGasReportModal.vue?vue&type=script&lang=js&"
import style0 from "./DayWasteGasReportModal.vue?vue&type=style&index=0&id=796e134e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e134e",
  null
  
)

export default component.exports